/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_JobsInputs */

const en_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Jobs`)
};

const fr_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soumettre ${i?.count} tâches`)
};

const de_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Jobs einreichen`)
};

const it_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invia ${i?.count} lavori`)
};

const ru_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отправить вакансии ${i?.count}`)
};

const es_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar ${i?.count} Empleos`)
};

const zh_cn2_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`提交 ${i?.count} 职位`)
};

const ja_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 求人を送信`)
};

const hi_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} नौकरियां जमा करें`)
};

const pt_pt2_submit_jobs = /** @type {(inputs: Submit_JobsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviar trabalhos ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Submit {count} Jobs" |
*
* @param {Submit_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_jobs = /** @type {((inputs: Submit_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_jobs(inputs)
	if (locale === "de") return de_submit_jobs(inputs)
	if (locale === "it") return it_submit_jobs(inputs)
	if (locale === "ru") return ru_submit_jobs(inputs)
	if (locale === "es") return es_submit_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_jobs(inputs)
	if (locale === "ja") return ja_submit_jobs(inputs)
	if (locale === "hi") return hi_submit_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_jobs(inputs)
	return en_submit_jobs(inputs)
});